import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, CircularProgress, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { getRankingHistory } from '../../services/ranking.service';

const RankingHistoryModal = ({ open, handleClose, jugId, jugNombre }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && jugId) {
      setLoading(true);
      getRankingHistory(jugId)
        .then((data) => {
          // Process data for chart
          const formattedData = data.map((item) => ({
            fecha: new Date(item.ranking.rkg_fecha).toLocaleDateString(),
            puntaje: item.his_puntaje,
          })).reverse(); // Reverse to show chronological order
          setHistory(formattedData);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [open, jugId]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          backgroundColor: '#374d5f',
          color: 'white',
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Historial de Ranking - {jugNombre}
          <IconButton onClick={handleClose} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : history.length > 0 ? (
          <Box height={400} mt={2} bgcolor="#e8e7ebff" p={2} borderRadius={2}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={history}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="fecha" tick={{ fontSize: 12, fill: '#333333' }} />
                <YAxis domain={['auto', 'auto']} tick={{ fill: '#333333' }} />
                <Tooltip />
                <Line type="monotone" dataKey="puntaje" stroke="#8884d8" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Box p={4} textAlign="center">
            <Typography>No hay historial disponible.</Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RankingHistoryModal;
